$(document).ajaxComplete(function(event, xhr, settings) {
    if (xhr.status === 302) {
        var redirectUrl = xhr.getResponseHeader('X-Redirect');
        if (redirectUrl !== null && typeof redirectUrl !== undefined) {
            var currentDomain = window.location.hostname;
            var responseDomain = new URL(redirectUrl).hostname;
            if (currentDomain === responseDomain) {
                Swal.fire({
                    position: 'top-center',
                    icon: 'info',
                    title: trans("session.timeout.text"),
                    showConfirmButton: false,
                    timer: 2500,
                    customClass: { popup: 'vf-confirmation-popup', },
                });
                document.getElementById('logout-form').submit();
            }
        } else {
            console.error('Redirect URL is null or undefined');
        }
    }
});